const OrdersRecord = () =>
  import(/* webpackChunkName: "Record" */ '@/pages/record/order/orders.vue')
const FurnitureTariffRecord = () =>
  import(
    /* webpackChunkName: "Record" */ '@/pages/record/tariffs/furniture/index.vue'
  )
const TrashTariffRecord = () =>
  import(
    /* webpackChunkName: "Record" */ '@/pages/record/tariffs/trash/index.vue'
  )
const TariffRecord = () =>
  import(/* webpackChunkName: "Record" */ '@/pages/record/tariffs/index.vue')
const UserRecord = () =>
  import(/* webpackChunkName: "Record" */ '@/pages/record/user/users.vue')
const AddressRecord = () =>
  import(/* webpackChunkName: "Record" */ '@/pages/record/user/address.vue')
const CourierRecord = () =>
  import(/* webpackChunkName: "Record" */ '@/pages/record/courier/couriers.vue')
const VehicleRecord = () =>
  import(
    /* webpackChunkName: "Record" */ '@/pages/record/transport/vehicle/index.vue'
  )
const DriverRecord = () =>
  import(
    /* webpackChunkName: "Record" */ '@/pages/record/transport/driver/index.vue'
  )

export default {
  name: 'record',
  path: 'record',
  meta: { label: 'record' },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'RecordOrders',
      path: 'order/orders',
      meta: { label: 'loads' },
      component: OrdersRecord
    },
    {
      name: 'RecordFurnitureTariff',
      path: 'tariffs/furniture/:furnitureTariff',
      meta: { label: 'tariffs' },
      component: FurnitureTariffRecord,
      props: true
    },
    {
      name: 'RecordTrashTariff',
      path: 'tariffs/trash/:trashTariff',
      meta: { label: 'tariffs' },
      component: TrashTariffRecord,
      props: true
    },
    {
      name: 'RecordTariff',
      path: 'tariffs/:tariff',
      meta: { label: 'tariffs' },
      component: TariffRecord,
      props: true
    },
    {
      name: 'RecordUser',
      path: 'user/users',
      meta: { label: 'users' },
      component: UserRecord
    },
    {
      name: 'RecordUserAddress',
      path: 'user/address',
      meta: { label: 'Addresses' },
      component: AddressRecord
    },
    {
      name: 'RecordCompany',
      path: 'courier/couriers',
      meta: { label: 'CompanyManage' },
      component: CourierRecord
    },
    {
      name: 'RecordVehicle',
      path: 'transport/vehicle',
      meta: { label: 'CarManage' },
      component: VehicleRecord
    },
    {
      name: 'RecordDriver',
      path: 'transport/driver',
      meta: { label: 'driver' },
      component: DriverRecord
    }
  ]
}
